import React from "react";

const Razor_VB_Logic = () => {
  return (
    <div className="tutorial-page">
      <h1>Razor VB Logic</h1>
      <p>This is the Razor VB Logic page content.</p>
    </div>
  );
};

export default Razor_VB_Logic;
